import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 60px;
  left: 2rem;
  z-index: 9999;
  width: 350px;
  background: white;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  display: inline-flex;
  animation: ${(props) => (props.$isClosing ? fadeOut : fadeIn)} 0.7s ease-out
    forwards;
  overflow: hidden;
`;

export const ModalContent = styled.div`
  align-self: stretch;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  display: inline-flex;
  padding: 1rem;
`;

export const IconWrapper = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  background: #27a84c;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

export const CirclesWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
`;

export const Circle = styled.div`
  position: absolute;
  opacity: 0.1;
  background: #27a84c;
  border-radius: 9999px;

  ${({ size }) => `
    width: ${size}px;
    height: ${size}px;
  `}
`;

export const TextWrapper = styled.div`
  flex: 1 1 0;
  align-self: stretch;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.span`
  color: #222;
  font-size: 12px;
  font-family: Poppins, sans-serif;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.5px;
  word-wrap: break-word;
`;

export const Subtitle = styled.span`
  color: #222;
  font-size: 12px;
  font-family: Poppins, sans-serif;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.5px;
  word-wrap: break-word;
`;

export const CloseButton = styled.button`
  width: 24px;
  height: 24px;
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const Body = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  display: flex;
  padding: 0 1rem 1rem;
  align-self: stretch;
`;

export const InfoCard = styled.div`
  align-self: stretch;
  padding: 12px;
  background: #f6f6f6;
  border-radius: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

export const InstructionWrapper = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
  width: 100%;
`;

export const InstructionText = styled.div`
  width: 285px;
  text-align: center;
  color: #222;
  font-size: 12px;
  font-family: Poppins, sans-serif;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.5px;
  word-wrap: break-word;
`;

export const ActionButton = styled.button`
  height: 32px;
  padding: 10px 16px;
  background: #c8131b;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
  color: white;
  font-size: 14px;
  font-family: Poppins, sans-serif;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.1px;
  word-wrap: break-word;
  border: none;
  cursor: pointer;
`;

export const ProgressBarContainer = styled.div`
  align-self: stretch;
  height: 16px;
  position: relative;
  margin: 0 1rem;
`;

export const ProgressBarWrapper = styled.div`
  width: 100%;
  height: 8px;
  left: 0;
  top: 4px;
  position: absolute;
  background: #ededed;
  border-radius: 21px;
`;

export const ProgressBar = styled.div`
  height: 8px;
  left: 0;
  top: 0;
  position: absolute;
  background: #c8131b;
  border-radius: 21px;
  width: ${({ progress }) => progress}%;
`;

export const ProgressIndicator = styled.div`
  width: 174.44px;
  height: 16px;
  left: 0;
  top: 0;
  position: absolute;
  justify-content: space-between;
  align-items: center;
  display: inline-flex;
`;
